'use client';

import { useTranslations, useLocale } from 'next-intl';
import { BentoHeading, BentoPara } from './StyleConstants';
import styles from './SleepCard.module.css';

const SleepGraphIllustration = (
  <svg
    width="561"
    height="292"
    viewBox="0 0 561 292"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="509.613" width="50.3885" height="48.1801" fill="white" />
    <rect
      x="509.613"
      y="48.1816"
      width="1.14519"
      height="33.58"
      fill="url(#paint0_linear_2_3)"
    />
    <rect
      x="501.592"
      y="81.7598"
      width="9.16154"
      height="48.1801"
      fill="#F973FE"
    />
    <rect
      x="501.592"
      y="129.94"
      width="1.14519"
      height="32.12"
      fill="url(#paint1_linear_2_3)"
    />
    <rect
      x="495.871"
      y="162.06"
      width="6.87116"
      height="48.1801"
      fill="#A34DCC"
    />
    <rect
      x="495.871"
      y="48.1816"
      width="1.14519"
      height="113.88"
      fill="url(#paint2_linear_2_3)"
    />
    <rect x="478.692" width="18.3231" height="48.1801" fill="white" />
    <rect
      x="478.692"
      y="48.1816"
      width="1.14519"
      height="113.88"
      fill="url(#paint3_linear_2_3)"
    />
    <rect
      x="471.818"
      y="162.06"
      width="8.01635"
      height="48.1801"
      fill="#A34DCC"
    />
    <rect
      x="471.818"
      y="48.1816"
      width="1.14519"
      height="113.88"
      fill="url(#paint4_linear_2_3)"
    />
    <rect x="456.93" width="16.0327" height="48.1801" fill="white" />
    <rect
      x="456.93"
      y="48.1816"
      width="1.14519"
      height="33.58"
      fill="url(#paint5_linear_2_3)"
    />
    <rect
      x="432.885"
      y="81.7598"
      width="25.1942"
      height="48.1801"
      fill="#F973FE"
    />
    <rect
      x="432.885"
      y="129.94"
      width="1.14519"
      height="32.12"
      fill="url(#paint6_linear_2_3)"
    />
    <rect
      x="423.721"
      y="162.06"
      width="10.3067"
      height="48.1801"
      fill="#A34DCC"
    />
    <rect
      x="423.721"
      y="129.94"
      width="1.14519"
      height="32.12"
      fill="url(#paint7_linear_2_3)"
    />
    <rect
      x="414.562"
      y="81.7598"
      width="10.3067"
      height="48.1801"
      fill="#F973FE"
    />
    <rect
      x="414.562"
      y="129.94"
      width="1.14519"
      height="32.12"
      fill="url(#paint8_linear_2_3)"
    />
    <rect
      x="401.963"
      y="162.06"
      width="13.7423"
      height="48.1801"
      fill="#A34DCC"
    />
    <rect
      x="401.963"
      y="129.94"
      width="1.14519"
      height="32.12"
      fill="url(#paint9_linear_2_3)"
    />
    <rect
      x="382.494"
      y="81.7598"
      width="20.6135"
      height="48.1801"
      fill="#F973FE"
    />
    <rect
      x="382.494"
      y="129.94"
      width="1.14519"
      height="32.12"
      fill="url(#paint10_linear_2_3)"
    />
    <rect
      x="337.832"
      y="162.06"
      width="45.8077"
      height="48.1801"
      fill="#A34DCC"
    />
    <rect
      x="337.832"
      y="129.94"
      width="1.14519"
      height="32.12"
      fill="url(#paint11_linear_2_3)"
    />
    <rect
      x="328.672"
      y="81.7598"
      width="10.3067"
      height="48.1801"
      fill="#F973FE"
    />
    <rect
      x="328.672"
      y="129.94"
      width="1.14519"
      height="32.12"
      fill="url(#paint12_linear_2_3)"
    />
    <rect x="298" y="162" width="32" height="48" fill="#A34DCC" />
    <rect
      x="298"
      y="48"
      width="1"
      height="114"
      fill="url(#paint13_linear_2_3)"
    />
    <rect x="291" width="8" height="48" fill="white" />
    <rect
      x="291"
      y="48"
      width="1"
      height="114"
      fill="url(#paint14_linear_2_3)"
    />
    <rect
      width="32.0654"
      height="48.1801"
      transform="matrix(-1 0 0 1 292.064 162)"
      fill="#A34DCC"
    />
    <rect
      x="259.955"
      y="129.94"
      width="1.14519"
      height="32.12"
      fill="url(#paint15_linear_2_3)"
    />
    <rect
      x="254.23"
      y="81.7598"
      width="6.87116"
      height="48.1801"
      fill="#F973FE"
    />
    <rect
      x="254.23"
      y="129.94"
      width="1.14519"
      height="32.12"
      fill="url(#paint16_linear_2_3)"
    />
    <rect
      x="185.52"
      y="162.06"
      width="69.8567"
      height="48.1801"
      fill="#A34DCC"
    />
    <rect
      x="185.52"
      y="129.94"
      width="1.14519"
      height="32.12"
      fill="url(#paint17_linear_2_3)"
    />
    <rect
      x="177.506"
      y="81.7598"
      width="9.16154"
      height="48.1801"
      fill="#F973FE"
    />
    <rect
      x="177.506"
      y="129.94"
      width="1.14519"
      height="32.12"
      fill="url(#paint18_linear_2_3)"
    />
    <rect
      x="67.5645"
      y="162.06"
      width="111.084"
      height="48.1801"
      fill="#A34DCC"
    />
    <rect
      x="67.5645"
      y="210.241"
      width="1.14519"
      height="33.58"
      fill="url(#paint19_linear_2_3)"
    />
    <rect
      x="53.8223"
      y="243.82"
      width="14.8875"
      height="48.1801"
      fill="#4D269B"
    />
    <rect
      x="53.8223"
      y="210.241"
      width="1.14519"
      height="33.58"
      fill="url(#paint20_linear_2_3)"
    />
    <rect
      x="46.9572"
      y="162.06"
      width="8.01635"
      height="48.1801"
      fill="#A34DCC"
    />
    <rect
      x="46.9572"
      y="210.241"
      width="1.14519"
      height="33.58"
      fill="url(#paint21_linear_2_3)"
    />
    <rect
      x="42.373"
      y="243.82"
      width="5.72596"
      height="48.1801"
      fill="#4D269B"
    />
    <rect
      x="42.373"
      y="210.241"
      width="1.14519"
      height="33.58"
      fill="url(#paint22_linear_2_3)"
    />
    <rect
      x="38.9355"
      y="162.06"
      width="4.58077"
      height="48.1801"
      fill="#A34DCC"
    />
    <rect
      x="38.9355"
      y="48.1816"
      width="1.14519"
      height="113.88"
      fill="url(#paint23_linear_2_3)"
    />
    <rect x="30.9199" width="9.16154" height="48.1801" fill="white" />
    <rect
      x="30.9199"
      y="48.1816"
      width="1.14519"
      height="113.88"
      fill="url(#paint24_linear_2_3)"
    />
    <rect
      x="24.0527"
      y="162.06"
      width="8.01635"
      height="48.1801"
      fill="#A34DCC"
    />
    <rect
      x="24.0527"
      y="48.1816"
      width="1.14519"
      height="113.88"
      fill="url(#paint25_linear_2_3)"
    />
    <rect x="17.1797" width="8.01635" height="48.1801" fill="white" />
    <rect
      x="17.1797"
      y="48.1816"
      width="1.14519"
      height="113.88"
      fill="url(#paint26_linear_2_3)"
    />
    <rect
      x="12.5996"
      y="162.06"
      width="5.72596"
      height="48.1801"
      fill="#A34DCC"
    />
    <rect
      x="12.5996"
      y="48.1816"
      width="1.14519"
      height="113.88"
      fill="url(#paint27_linear_2_3)"
    />
    <rect width="13.7423" height="48.1801" fill="white" />
    <defs>
      <linearGradient
        id="paint0_linear_2_3"
        x1="510.186"
        y1="48.1816"
        x2="510.186"
        y2="81.7617"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F973FE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2_3"
        x1="502.164"
        y1="129.94"
        x2="502.164"
        y2="162.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2_3"
        x1="496.444"
        y1="48.1816"
        x2="496.444"
        y2="162.062"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2_3"
        x1="479.264"
        y1="48.1816"
        x2="479.264"
        y2="162.062"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2_3"
        x1="472.391"
        y1="48.1816"
        x2="472.391"
        y2="162.062"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2_3"
        x1="457.502"
        y1="48.1816"
        x2="457.502"
        y2="81.7617"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F973FE" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2_3"
        x1="433.457"
        y1="129.94"
        x2="433.457"
        y2="162.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2_3"
        x1="424.293"
        y1="129.94"
        x2="424.293"
        y2="162.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_2_3"
        x1="415.135"
        y1="129.94"
        x2="415.135"
        y2="162.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_2_3"
        x1="402.535"
        y1="129.94"
        x2="402.535"
        y2="162.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_2_3"
        x1="383.067"
        y1="129.94"
        x2="383.067"
        y2="162.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_2_3"
        x1="338.405"
        y1="129.94"
        x2="338.405"
        y2="162.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_2_3"
        x1="329.244"
        y1="129.94"
        x2="329.244"
        y2="162.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_2_3"
        x1="298.5"
        y1="48"
        x2="298.5"
        y2="162"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_2_3"
        x1="291.5"
        y1="48"
        x2="291.5"
        y2="162"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_2_3"
        x1="260.528"
        y1="129.94"
        x2="260.528"
        y2="162.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_2_3"
        x1="254.803"
        y1="129.94"
        x2="254.803"
        y2="162.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_2_3"
        x1="186.092"
        y1="129.94"
        x2="186.092"
        y2="162.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_2_3"
        x1="178.078"
        y1="129.94"
        x2="178.078"
        y2="162.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F973FE" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_2_3"
        x1="68.137"
        y1="210.241"
        x2="68.137"
        y2="243.821"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A34DCC" />
        <stop offset="1" stopColor="#4D269B" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_2_3"
        x1="54.3949"
        y1="210.241"
        x2="54.3949"
        y2="243.821"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A34DCC" />
        <stop offset="1" stopColor="#4D269B" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_2_3"
        x1="47.5297"
        y1="210.241"
        x2="47.5297"
        y2="243.821"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A34DCC" />
        <stop offset="1" stopColor="#4D269B" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_2_3"
        x1="42.9456"
        y1="210.241"
        x2="42.9456"
        y2="243.821"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A34DCC" />
        <stop offset="1" stopColor="#4D269B" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_2_3"
        x1="39.5081"
        y1="48.1816"
        x2="39.5081"
        y2="162.062"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_2_3"
        x1="31.4925"
        y1="48.1816"
        x2="31.4925"
        y2="162.062"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint25_linear_2_3"
        x1="24.6253"
        y1="48.1816"
        x2="24.6253"
        y2="162.062"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint26_linear_2_3"
        x1="17.7523"
        y1="48.1816"
        x2="17.7523"
        y2="162.062"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
      <linearGradient
        id="paint27_linear_2_3"
        x1="13.1722"
        y1="48.1816"
        x2="13.1722"
        y2="162.062"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#A34DCC" />
      </linearGradient>
    </defs>
  </svg>
);

export const SleepCard = ({ className }: { className?: string }) => {
  const t = useTranslations('ring');
  const locale = useLocale();

  return (
    <div className={`${styles.root} container${className ? ` ${className}` : ''}`}>
      <BentoHeading>{t('ring.bentoSection.sleepCard.head')}</BentoHeading>
      <BentoPara>
        {locale !== 'ja' ? t('ring.THE') : ''}
        {locale !== 'ja' ? ' ' : ''}
        <b>{t('ring.SLEEP_INDEX')}</b>
        {t('ring.bentoSection.sleepCard.desc')}
      </BentoPara>
      {SleepGraphIllustration}
    </div>
  );
};
